import { Table } from "@/features/Table";
import { useBulkDeleteControls } from "@/features/Edit/useBulkDeleteControls";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";
import { type C5TimeSerie, columns } from "./columns";
import { type FilterC5TimeSeriesSchema, FilterC5TimeSeries } from "./filter";

const client = Clients.C5;
const table_name = Tables.C5_TIME_SERIES;

export const C5TimeSeriesTable = () => {
  const { selectionActions, modal } = useBulkDeleteControls<C5TimeSerie>({
    client,
    table_name,
    resourceLabel: "Valorisation",
  });

  return (
    <>
      <Table<C5TimeSerie, FilterC5TimeSeriesSchema>
        label="Valorisation"
        client={client}
        table_name={table_name}
        columns={columns}
        filter={<FilterC5TimeSeries />}
        actions={[
          {
            label: "actions.new",
            route: `${client}/${table_name}/new`,
          },
        ]}
        enableRowSelection
        selectionActions={selectionActions}
      />
      {modal}
    </>
  );
};
